import type { FaireProductEntity } from "../../entity_types/product";

export const p_2urj9tzhvw: FaireProductEntity = {
  token: "p_2urj9tzhvw",
  type: "product",
  name: "Balloon Dog Pet Bowl",
  brandToken: "b_6qajwqdzz3",
  brandName: "BigMouth Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/07d59d127839a3ef6d28c286b66a72297df64ba6bb74bf607adbb88fcb4b2cb7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b8ed87f85498e347a982953e9ac4ec04f01041dca7dfbdd411a63c41db9aca0c.jpeg",
    "https://cdn.faire.com/fastly/8d6f8abc76c9b49b71c9f7e8e9c955fb2803c849f04225489fc25bf3025391d6.jpeg",
    "https://cdn.faire.com/fastly/34f385dacbb411971a5486c894eb42760bafa9a5a66bb359248af7295c354ce3.jpeg",
    "https://cdn.faire.com/fastly/ae58dbf364bf6245ad6e2799408229c181ddf67879915f1da3c914088baad5f0.jpeg",
    "https://cdn.faire.com/fastly/6dd3ad1775b549c3a5806303017e713f31cc51376fd875b5247468ec21a34413.jpeg",
  ],
  priceDollars: 20.77,
  description:
    "Paws-itively Adorable Balloon Dog Shaped Elevated Dog Bowl Stand - For the Fashionable Furry Friend! Introducing our delightfully chic Balloon Dog Shaped Dog Bowl Stand, a part of our fresh pet collection, designed for the trendiest tails on the block. This elevated dog bowl not only upgrades mealtime for your pets, but also unleashes a fun, aesthetic twist to your home. Our Balloon Dog Shaped Dog Bowl Stand is no mere dog bowl - it's a pupper’s paradise! Inspired by the playful charm of a balloon dog, this pet bowl holder turns a necessary pet accessory into a bow-wow-worthy conversation piece. As part of our newest collection, this elevated dog bowl stand joins our range of inventive designs, which includes a rubber tire, a cheese wheel, and a balloon dog pet bowl holder.",
  tags: [],
  msrpDollars: 41.56,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:05.991Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
